export default __webpack_public_path__ + "static/media/quadrantcross.1d199d5b.gif";